import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11836cf8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["cx", "cy", "rx", "ry", "stroke", "stroke-width", "stroke-dasharray"]

import { toRef } from 'vue'
import type { PPTElementOutline } from '@/types/slides'
import useElementOutline from '@/views/components/element/hooks/useElementOutline'


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageEllipseOutline',
  props: {
    width: {},
    height: {},
    outline: {}
  },
  setup(__props: any) {

const props = __props

const {
  outlineWidth,
  outlineColor,
  strokeDashArray,
} = useElementOutline(toRef(props, 'outline'))

return (_ctx: any,_cache: any) => {
  return (_ctx.outline)
    ? (_openBlock(), _createElementBlock("svg", {
        key: 0,
        class: "image-ellipse-outline",
        overflow: "visible",
        width: _ctx.width,
        height: _ctx.height
      }, [
        _createElementVNode("ellipse", {
          "vector-effect": "non-scaling-stroke",
          "stroke-linecap": "butt",
          "stroke-miterlimit": "8",
          fill: "transparent",
          cx: _ctx.width / 2,
          cy: _ctx.height / 2,
          rx: _ctx.width / 2,
          ry: _ctx.height / 2,
          stroke: _unref(outlineColor),
          "stroke-width": _unref(outlineWidth),
          "stroke-dasharray": _unref(strokeDashArray)
        }, null, 8, _hoisted_2)
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})